import { TypographyPresentationProps } from "@insite/mobius/Typography";

const pageTitleProps: TypographyPresentationProps = {
    variant: "h1",
    forwardAs: "h1",
};

export default pageTitleProps;
